import { render, staticRenderFns } from "./AsiMarkDownViewer.vue?vue&type=template&id=04082af2&scoped=true"
import script from "./AsiMarkDownViewer.vue?vue&type=script&lang=ts"
export * from "./AsiMarkDownViewer.vue?vue&type=script&lang=ts"
import style0 from "./AsiMarkDownViewer.vue?vue&type=style&index=0&id=04082af2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04082af2",
  null
  
)

export default component.exports